var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-wrapper',[_c('detail-wrapper',{attrs:{"chamber":"president"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }